import React, { FunctionComponent, ReactElement, useContext, useEffect, useState } from 'react'
import { AppStatus } from '@models/Common'
import { Outlet, useNavigate } from 'react-router-dom'
import { Pages } from '@models/Pages'
import { SurveyContext } from '@context/SurveyContext'
import AppLoader from '@components/AppLoader/AppLoader'
import ResultWidget from '@components/ResultWidget/ResultWidget'
import useVirtualKeyboard, { KeyboardVisibility, KEYBOARD_VISIBILITY } from '@hooks/useVirtualKeyboard'
import WithMenu from '@hoc/WithMenu/WithMenu'
import './SurveyLayout.scss'
import { useEnsureSurveyIsAvailableAndConsent } from '@hooks/useEnsureSurveyIsAvailableAndConsent'

export const SurveyLayout: FunctionComponent<{}> = (): ReactElement => {
  useEnsureSurveyIsAvailableAndConsent()
  const [keyboardVisibility, setKeyboardVisibility] = useState<KeyboardVisibility>(KEYBOARD_VISIBILITY.HIDDEN)
  const navigate = useNavigate()

  const { status, step } = useContext(SurveyContext)

  useVirtualKeyboard(setKeyboardVisibility)
  useEffect(() => {
    return () => {
      setKeyboardVisibility(KEYBOARD_VISIBILITY.HIDDEN)
    }
  }, [])

  useEffect(() => {
    navigate(`/${Pages.Survey}/${step}`)
  }, [step])

  return (
    <div className={`Survey mobile-keyboard-${keyboardVisibility}`}>
      <ResultWidget />
      <div className="Survey-step">
        {status === AppStatus.PENDING && <AppLoader />}
        <Outlet />
      </div>
    </div>
  )
}

export default WithMenu(SurveyLayout)
